import { createGlobalStyle, css } from "styled-components";

const GlobalStyles = createGlobalStyle`

*, body{
    margin: 0;
    padding: 0;
}

* {
    list-style: none;
    vertical-align: baseline;
    outline: 0!important;
}

body {
    font-family: "Gotham", "Helvetica Neue",Helvetica,Arial,sans-serif;
    font-size: 14px;
    font-weight: 300;
    overflow: visible !important;

    &#menu-angular{
        background: transparent;
        
        iframe {
            display: none !important;
        }

        div[class="grecaptcha-badge"]{
            display: none;
        }
    }

    &#open-popover{
        padding-right: 0 !important;
        overflow: hidden !important;
    }

    &.modal-open {
        overflow: hidden !important; 
    }

    &.menu-closed{
        .menu-portal-ies {
            height: 0px;
            padding: 0;
            overflow: hidden;
        }
    }
}

#root{
    display: flex;
    min-height: 100vh;     
}

p{
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.25px;
    color: #98A2B3;
}

h2{
    font-style: normal;
    font-weight: 900;
    font-size: 24px;
    line-height: 40px;
    color: #475466;
    margin: 32px 0 25px 0; 
}

h3{
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 18px;
    color: #475466;
    margin-bottom: 30px;
    margin-top: 60px;
}

a{
    color: #4A90E2 !important;
    cursor: pointer;
}

.hide{
    display:none;
}

.btn-primary{
    font-size: 12px;
    background: #4A90E2;
    border-color: #4A90E2;
    border-radius: 50px;
    padding: 0px 30px;
    height: 36px;
    margin-bottom: 30px;
}

.btn-outline{
    font-size: 12px;
    padding: 0px 30px;
    height: 36px;
    border-color: #4A90E2;
    color: #4A90E2;
    background: #F5F7FA;
    mix-blend-mode: normal;
    border-radius: 50px;
    margin-bottom: 30px;

    &:hover{
        color: #4A90E2;    
    }
}

.btn-upload-list{
    height: 36px;
    font-size: 12px;
    line-height: 22px;
    color: #4A90E2;
    border: 1px solid #4A90E2;
    box-sizing: border-box;
    border-radius: 50px;
    background: #FFF;
    padding: 0px 30px;
    
    .svg-inline--fa{
        transform: rotate(180deg);
        margin-right: 8px;
    }
}


.horizontal-bar{
    border-bottom: 1px solid #E4E9F0;
    margin: 40px 0;
    height: 0;
}

legend{
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 15px;
    color: #475466;
    margin-bottom: 30px;

    &.legend-small{
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 15px;
        color: #475466;
        margin-bottom: 15px;
    }
}

label{
    font-style: normal;
    font-weight: 500;
    font-size: 11px;
    line-height: 12px;
    color: #98A2B3;
}

input.form-control[type=password],
input.form-control[type=text],
input.form-control[type=date], 
input.form-control[type=email]{
    color: #98A2B3;
    background: #FFFFFF;
    border: 1px solid #E4E9F0;  
    box-sizing: border-box;
    border-radius: 5px;
    height: 46px;
    margin-bottom: 15px;
    font-size: 12px;

    &::placeholder{
        font-weight: normal;
        font-size: 11px;
        line-height: 12px;
        display: flex;
        align-items: center;
        color: #98A2B3;
    }
    
    &::-moz-placeholder {
        line-height: 21px;
    }

    &.is-invalid{
        border-color: #dc3545 !important;
    }
}

.form-control.is-invalid, .was-validated .form-control:invalid,
.form-control.is-invalid:focus, .was-validated .form-control:invalid:focus {
  background-image: none;
  box-shadow: none;
}

.form-control.is-valid:focus, .was-validated .form-control:valid:focus,
.form-control.is-valid, .was-validated .form-control:valid {
  border-color: #E4E9F0;
  background-image: none;
  box-shadow: none;
}

.invalid-feedback{
    margin-top: -12px;
}

.error-msg{
    color: #dc3545 !important;
    font-size: 10px;
    font-weight: 300;
    bottom: -24px;
    position: absolute;
}

.btn-enviar-lista{
    float: right;
    margin-top: 30px;
}

.custom-radio{
    margin-bottom: 30px
}

.radio-express .custom-control-label{
    padding-top: 6px;
}

.select-padrao{
    margin-top: 6px;
    button{
        width: 100%;
        padding: 0 18px;
    }

    .dropdown-menu{
        max-height: 400px;
        overflow-y: auto;
    }
}

.select-padrao-especial{
    margin-top: 6px;
    button{
        width: 100%;
        padding: 0 18px;
        white-space: normal;
    }

    .dropdown-menu{
        max-height: 400px;
        overflow-y: auto;
    }
}

/* width */
::-webkit-scrollbar {
  width: 5px;
  margin: 0 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #FFF; 
  padding: 0 5px;
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #E4E9F0; 
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #E4E9F0; 
}

select.form-control{
    background: #4A90E2;
    border-radius: 18px;
    color: #fff;
    font-weight: bold;
    font-size: 12px;
    line-height: 10px;
    height: 36px;
    margin-top: 4px;
    -moz-appearance:none;
}

select.form-control option{
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    color: #98A2B3;
}

.btn-primary:disabled {
    background-color: #E4E9F0;
    border-color: #E4E9F0;
}

.btn-download{
    width: 150px;
    text-align: center;
    color: #4A90E2;
    border: 1px solid #4A90E2;
    box-sizing: border-box;
    border-radius: 50px;
    background-color: #F5F7FA;
    font-size: 12px;
    line-height: 22px;
    padding: 0 20px;

    .svg-inline--fa{
        margin-right: 8px;
    }
}

.custom-file{
    
    width: 150px;
    text-align: center;
    height: 36px;

    .svg-inline--fa{
        margin-right: 8px;
    }
    .custom-file-label{
        height: 36px;
        font-size: 12px;
        line-height: 22px;
        color: #4A90E2;
        border: 1px solid #4A90E2;
        box-sizing: border-box;
        border-radius: 50px;
    
        &::after{
            display: none;
        }
    }
}

.talign-right{
    text-align: right;
}

.marginb-less{
    margin-bottom: 0;
}

.list-group-item{
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 13px;
    color: #7A8799;
    padding: 18px 15px;
    border: 0;
    margin: 2.5px 0;

    a{
        margin-left: 20px;

        .svg-inline--fa{
            margin-right: 8px;
        }

        &:first-of-type{
            margin-left: 0
        }
    }
}

.header-list{
    padding: 0 15px;
    font-weight: 500;
    font-size: 12px;
    line-height: 13px;
    color: #98A2B3;
    margin: 15px 0;
}

.modal-content {
  background: #F5F7FA;

  .form-group {
    margin: 0;
  }
}

.modal-confirmacao{
    .btn-primary, .btn-outline{
        margin: 0 15px;
    }  
    .btn-primary{
        margin-right: 0;
    }
}

@media (min-width: 1200px){
    .container{
        max-width: 1234px !important;
    }

}

`;

const scrollbarStyle = css`

    ::-webkit-scrollbar {
        width: 2px;
        height: 8px;
        background-color: #E4E4E3;
    }

    ::-webkit-scrollbar-track {
        width: 2px;
        border-radius: 2px;
        background-color: #E4E4E3; 
    }

    ::-webkit-scrollbar-thumb {
        border-radius: 2px;
        -webkit-box-shadow: inset 0 0 6px rgb(0 0 0 / 30%);
        background-color: #313130; 
    }

    ::-webkit-scrollbar-thumb:hover {
        background: #313130;
    }
`

export const FrameContentScrollbarStyled = createGlobalStyle`
    ${scrollbarStyle};
`

export default GlobalStyles;
